import { render } from "./Expenses.vue?vue&type=template&id=cb4fbd72&scoped=true"
import script from "./Expenses.vue?vue&type=script&lang=js"
export * from "./Expenses.vue?vue&type=script&lang=js"

import "./Expenses.vue?vue&type=style&index=0&id=cb4fbd72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cb4fbd72"

export default script